import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {LoadingService} from '../../services/loading/loading.service';
import { HttpErrorResponse } from '@angular/common/http';
import {AgencyUserService} from './agency-user.service';
import {AlertService} from '../../services/alert/alert.service';
import {AgencyUserDetailsByOrgId, UserEntity} from './agency-user';
import {UserService} from '../../services/user/user.service';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import AppConstants, {
  BusinessType as BT,
  carrier_user,
  carrier_user_admin, carrier_user_paygov, carrier_user_RF,
  system_admin
} from '../../shared/common-components/AppConstants';
import {AgencyProfileService} from '../../services/agency-profile/agency-profile.service';
import {StateCountry} from '../../shared/common-components/common-structure';
import {AgencyMasterService} from '../../services/agency-master/agency-master.service';
import {UserSelectionService} from '../../shared/user-selection/user-selection-service';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import moment from 'moment';

@Component({
    selector: 'app-agency-user',
    templateUrl: './agency-user.component.html',
    styleUrls: ['./agency-user.component.css'],
    standalone: false
})
export class AgencyUserComponent implements OnInit, OnDestroy {
  @ViewChild(ModalDirective, {static: true}) createModal: ModalDirective;

  userListResultsGridOptions: GridOptions = this.initializeGridOptions();
  agencyUserDetailsByOrgId: AgencyUserDetailsByOrgId = null;
  userAlreadyExistsMessage = '';
  disabledResetPassword: Boolean = false;
  reactivateUser: Boolean = false;
  agencyUserList: any = [];
  agencyUserRoles: any = [];
  allAgencyRoles: any = [];
  carrierUserRoles: any = [];
  userEntity: UserEntity = null;
  routeParamOrganizationId: number;
  routeParamUserId: number;
  routeParamUserIdFromUserProfile: number;
  routeParamIsAgencyUser: string;
  routeParamIsSystemAdmin: string;
  routeParamIsAuditor: string;
  routeParamIsFromUserProfile: string;
  agencyUserForm: FormGroup;
  organizationId: number;
  private tmssloader;
  title = '';
  isCreate: boolean;
  show: boolean;
  message: string;
  roles: any = [];
  role: any;
  isAgencyUser: boolean;
  isSytemAdmin: boolean;
  isAuditor: boolean;
  isFromUserProfile: boolean;
  agencyUserRole: any;
  currentRoles: any;
  columnDefs: any;
  itemsPerPage = 10;
  totalItems = 0;
  currentPage = 1;
  pageReset = false;
  previousPage = 0;
  agencyUserListSliced: any = null;
  pageMap: Map<number, any> = new Map<number, any>();
  showingStart: number;
  showingEnd: number;
  modalRef: BsModalRef;
  generalInfoRouterLink: string;
  private gridApi;
  public overlayNoRowsTemplate;
  agencyBureauCode: any;
  currentRecordIndex: number;
  idOfSelectedUser: number;
  carrierAgencyDetails: any;
  displayTitle: any;
  userEmail: string;
  suspenededUser:Boolean = false;

  constructor(private agencyUserService: AgencyUserService,
              private fb: FormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private modalService: BsModalService,
              private route: ActivatedRoute,
              private userService: UserService,
              private router: Router,
              private agencyProfileService: AgencyProfileService,
              private agencyMasterService: AgencyMasterService,
              private userSelectionService: UserSelectionService) {
    this.tmssloader = this.loader;
    this.overlayNoRowsTemplate = '<span>Your search returned no users.</span>';
    this.agencyUserForm = this.fb.group({
      firstName: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]),
      middleInitial: new FormControl(''),
      lastName: new FormControl('', [Validators.required, Validators.maxLength(35), Validators.pattern('[a-zA-Z ]*')]),
      email: new FormControl('', [Validators.required, CommonValidators.email]),
      phone: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(15), CommonValidators.numeric]),
      mobilePhone: new FormControl('', [Validators.minLength(10), CommonValidators.numeric]),
      phoneExtension: new FormControl('', [CommonValidators.numeric]),
      id: new FormControl(''),
      agencyUserRole: new FormControl('', Validators.required),
      roles: new FormControl('')
    });
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  getUserListQueryResultColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'Email',
          field: 'email',
          cellRenderer: params => {
            return '<a tabindex="0">' + params.data.email + '</a>';
          },
          filter: 'agTextColumnFilter',
          onCellClicked: params => this.createEdit('edit', this.createModal, params.data)
        },
      {
        headerName: 'First Name',
        field: 'firstName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Middle Initial',
        field: 'middleInitial',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Last Name',
        field: 'lastName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Phone',
        field: 'phone',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Phone Extension',
        field: 'phoneExtension',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Role',
        field: 'role',
        cellRenderer: params => params.data.roles[0].name,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TMSS 2.0 User Status',
        field: 'status',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Last Login Date',
        field: 'lastLoginDate',
        cellRenderer: (params: any) => {
          if (AppConstants.isNotNullCondition(params.data.lastLoginDate)) {
            return moment(params.data.lastLoginDate).utcOffset(-4).format("MM/DD/YYYY hh:mm A");

          }
        },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'User Creation Date',
        field: 'createdDate',
        cellRenderer: (params: any) => {
          if (AppConstants.isNotNullCondition(params.data.createdDate)) {
            return moment(params.data.createdDate).utcOffset(-4).format("MM/DD/YYYY hh:mm A");

          }
        },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Okta User Status',
        field: 'oktaStatus',
        cellRenderer: (params: any) => {
          if (AppConstants.isNotNullCondition(params.data.oktaStatus)) {
            return params.data.oktaStatus.charAt(0).toUpperCase() + params.data.oktaStatus.toLowerCase().slice(1);
          }
        },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'In TMSS Group',
        field: 'tmssgroup',
        cellRenderer: (params: any) => {
          return params.data.tmssgroup ? 'Yes' : 'No';
        },
        filter: 'agTextColumnFilter'
      }
    ];
  }

  ngOnInit() {
    this.columnDefs = this.getUserListQueryResultColumnDefs();
    this.tmssloader.show();
    this.routeParamOrganizationId = this.route.snapshot.queryParams['organizationId'];
    this.routeParamIsAgencyUser = this.route.snapshot.queryParams['isAgencyUser'];
    this.routeParamIsSystemAdmin = this.route.snapshot.queryParams['isSystemAdmin'];
    this.routeParamIsFromUserProfile = this.route.snapshot.queryParams['isFromUserProfile'];
    this.routeParamIsAuditor = this.route.snapshot.queryParams['isAuditor'];
    this.isAgencyUser = (this.routeParamIsAgencyUser == 'true');
    this.isSytemAdmin = (this.routeParamIsSystemAdmin == 'true');
    this.isAuditor = (this.routeParamIsAuditor == 'true');
    this.isFromUserProfile = (this.routeParamIsFromUserProfile == 'true');
    this.routeParamUserId = this.route.snapshot.queryParams['userId'];
    this.routeParamUserIdFromUserProfile = this.route.snapshot.queryParams['userIdFromUserProfile'];
    this.displayTitle = (this.routeParamIsAgencyUser == 'true') ? 'Agency User List' : 'TSP User List';
    this.getAgencyUserRoles(this.isAuditor);
    this.getCarrierUserRoles();
    this.loadList();
  }

  loadList() {
    if (this.routeParamUserId) {
      this.getAgencyUsersListByUserId(this.routeParamUserId);
    } else if (this.routeParamOrganizationId) {
      this.getAgencyUsersList(this.routeParamOrganizationId);
    } else {
      this.tmssloader.hide();
    }
  }

  // Get the user informaiton for supplied user id as part of the parameter
  getAgencyUsersListByUserId(userId: number) {
    this.agencyUserList = [];
    this.agencyUserDetailsByOrgId = null;
    this.tmssloader.show();
    this.userService.getUserByUserId(userId).subscribe(user => {
      this.agencyUserList = [];
      if (user) {
        if (this.routeParamUserId && this.routeParamOrganizationId) {
          this.userSelectionService.getSingleUserRolesWithUserIdAndOrgId(userId, this.routeParamOrganizationId).subscribe(userRoles => {
            if (AppConstants.isNotNullCondition(userRoles)) {
              this.agencyUserRole = userRoles;
              this.currentRoles = AppConstants.getRoles(userRoles.roleId);
              user.roles = this.currentRoles;
              user.oktaStatus = this.agencyUserRole.userEntity.oktaStatus;
              this.agencyUserList.push(user);
              this.gridApi.setRowData(this.agencyUserList);
            }
          });
        } else {
          this.agencyUserList.push(user);
          this.gridApi.setRowData(this.agencyUserList);
        }
      }
      this.tmssloader.hide();
    }, (error) => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving agencyUsersList');
    });
  }

  // Get the agency and carrier user list for a particular organization
  getAgencyUsersList(organizationId: number) {
    this.agencyUserList = [];
    this.agencyUserDetailsByOrgId = null;
    this.agencyUserService.getUsersListByOrgId(organizationId)
      .subscribe(data => {
        if (!this.isAgencyUser && AppConstants.isNotNullCondition(data)) {
          if (AppConstants.isNotNullCondition(data.carrierEntity)) {
            this.carrierAgencyDetails = data.carrierEntity.scac + '-' + data.carrierEntity.scacName;
          }
        } else {
          this.agencyMasterService.getAgencyBureauDetails(organizationId).subscribe(response => {
            const agencyBureauDetails = response;
            this.agencyProfileService.getAllStates('State').subscribe(
              states => {
                const state: StateCountry = states.find(x => {
                  return x.stateCountryId === data.stateId;
                });
                if (AppConstants.isNotNullCondition(agencyBureauDetails)) {
                  const agencyCode = agencyBureauDetails ? agencyBureauDetails.agencyCode : '';
                  const bureauCode = agencyBureauDetails ? agencyBureauDetails.bureauCode : '';
                  const agencyBureauName = agencyBureauDetails ? agencyBureauDetails.agencyBureauName : '';
                  this.agencyBureauCode = agencyCode + '' + bureauCode;
                  if (AppConstants.isNotNullCondition(this.agencyBureauCode) && (organizationId != 1001 && organizationId != 972 && organizationId != 971 && organizationId != 976 && organizationId != 4102)) {
                    this.agencyUserRoles = this.agencyUserRoles.filter(role => role.name !== 'System Admin');
                  } else {
                    this.agencyUserRoles = Object.assign(this.allAgencyRoles);
                  }
                  const city = data ? data.city : '';
                  const stateCountryCode = state ? state.stateCountryCode : '';
                  this.carrierAgencyDetails = agencyCode + '' + bureauCode + '-' + agencyBureauName + `<br>` + ' Location: ' + city + '-' + stateCountryCode;
                } else {
                  this.carrierAgencyDetails = '';
                }
              }, (error) => {
                this.alertService.error('Error while getting states list.');
              });
          }, error => {
            this.alertService.error('Error while getting agency bureau details.');
          });
        }
        this.agencyUserDetailsByOrgId = data;
        this.agencyUserList = this.agencyUserDetailsByOrgId.userList;
        // this.setupPagination();
        this.gridApi.setRowData(this.agencyUserList);
        this.tmssloader.hide();
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('There was an error retrieving agencyUsersList');
      });
  }

  // read and set the form values, when modal gets opened
  createEdit(from?, modal?, userDetails?) {
    this.userAlreadyExistsMessage = '';
    if (from === 'create') {
      if (true === this.isAgencyUser) {
        this.title = 'Create Agency User';
      } else {
        this.title = 'Create TSP User';
      }
      this.userAlreadyExistsMessage = '';
      this.isCreate = true;
      this.agencyUserForm.controls['firstName'].setValue('');
      this.agencyUserForm.controls['middleInitial'].setValue('');
      this.agencyUserForm.controls['lastName'].setValue('');
      this.agencyUserForm.controls['phone'].setValue('');
      this.agencyUserForm.controls['mobilePhone'].setValue('');
      this.agencyUserForm.controls['phoneExtension'].setValue('');
      this.agencyUserForm.controls['email'].setValue('');
      this.agencyUserForm.controls['agencyUserRole'].setValue('Select a Permission..');
      this.agencyUserForm.reset({
        firstName: '',
        middleInitial: '',
        lastName: '',
        phone: '',
        mobilePhone: '',
        phoneExtension: '',
        email: '',
        agencyUserRole: ''
      });
      this.message = '';
      modal.show();
    } else if (from === 'edit') {
      this.message = '';
      if (userDetails.email !== null || userDetails.email !== undefined || userDetails.email !== '') {
        if (this.splitEmailDomain(userDetails.email).toString().toUpperCase() === 'GSA.GOV' || userDetails.oktaStatus === "SUSPENDED") {
          this.disabledResetPassword = true;
        } else {
          if (this.splitEmailDomain(userDetails.email).toString().toUpperCase() !== 'GSA.GOV' && (userDetails.oktaStatus === null || userDetails.oktaStatus === '')) {
            this.disabledResetPassword = false;
          }else this.disabledResetPassword = false;
        }
        if (false === this.isSytemAdmin && this.splitEmailDomain(userDetails.email).toString().toUpperCase() !== 'GSA.GOV' && userDetails.oktaStatus === "SUSPENDED") {
          this.message = 'This User is currently in suspended status. Please contact the TMSS 2.0 Help Desk at 1 (866) 668-3472 or gsatmsshelp@gsa.gov to reactivate this account.';
          this.suspenededUser = true;
        } else {
          this.suspenededUser = false;
        }
        if (true === this.isSytemAdmin && this.splitEmailDomain(userDetails.email).toString().toUpperCase() !== 'GSA.GOV' && userDetails.oktaStatus === "SUSPENDED") {
          this.message = 'This User is currently in suspended status. By clicking Reactivate User button, the system will send out password reset instructions to the user.';
          this.reactivateUser = true;
        } else {
          //this.disabledResetPassword = false;
          this.reactivateUser = false;
        }
      }
      this.currentRecordIndex = this.agencyUserList.indexOf(userDetails);
      if (true === this.isAgencyUser) {
        this.title = 'Edit Agency User';
      } else {
        this.title = 'Edit TSP User';
      }
      this.isCreate = false;
      this.agencyUserForm.controls['firstName'].setValue(userDetails.firstName);
      this.agencyUserForm.controls['middleInitial'].setValue(userDetails.middleInitial);
      this.agencyUserForm.controls['lastName'].setValue(userDetails.lastName);
      this.agencyUserForm.controls['phone'].setValue(userDetails.phone);
      this.agencyUserForm.controls['mobilePhone'].setValue(userDetails.mobilePhone);
      this.agencyUserForm.controls['phoneExtension'].setValue(userDetails.phoneExtension);
      this.agencyUserForm.controls['email'].setValue(userDetails.email);
      this.agencyUserForm.controls['id'].setValue(userDetails.id);
      this.agencyUserForm.controls['agencyUserRole'].setValue(userDetails.roles[0].name);
      this.message = '';
      modal.show();
    }
  }

  /**
   * @description splits email into name and domain
   * TODO move to common functions file
   */
  splitEmailDomain(email) {
    const name = email.substring(0, email.lastIndexOf('@'));
    const domain = email.substring(email.lastIndexOf('@') + 1);
    return domain;
  }

  // Get Agency User Roles from DB
  getAgencyUserRoles(isAuditor) {
    this.agencyUserRoles = [];
    this.agencyUserService.getAgencyUserRoles()
      .subscribe(data => {
        if (isAuditor) {
          this.allAgencyRoles = data.filter(role => role.name ==='Agency Auditor');
          this.agencyUserRoles = data.filter(role => role.name ==='Agency Auditor');
        } else {
          this.allAgencyRoles = data.filter(role => role.name !=='Agency Auditor');
          this.agencyUserRoles = data.filter(role => role.name !=='Agency Auditor');
        }

      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('There was an error retrieving agencyUserRoles');
      });
  }

  // Get Carrier User Roles from DB
  getCarrierUserRoles() {
    this.carrierUserRoles = [];
    this.agencyUserService.getCarrierUserRoles()
      .subscribe(data => {
        this.userService.getCurrentUserObservable().subscribe(currentUser => {
          if (currentUser) {
            const businessType = currentUser.permissions;
            if (businessType === BT.FRT) {
              this.carrierUserRoles = data.filter(x => x.role !== 'TSP User Pay.gov');
            } else {
              this.carrierUserRoles = data;
            }
          }
        }, (error) => {
          console.log("ERROR WHILE RETRIVING DATA", error);
        });
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('There was an error retrieving TSPUserRoles');
      });
  }

  // Function is used to create a new Agency / carrier user depends on the isAgencyUser flag
  createUser(creatModal?) {
    const userEmail = this.agencyUserForm.get('email').value.trim();
    const emails = this.agencyUserList.map(x => x.email);
    if (emails.indexOf(userEmail) !== -1) {
      this.userAlreadyExistsMessage = 'User already exists for this organization.';
    } else {
      this.userAlreadyExistsMessage = '';
      this.userSelectionService.getMultiUserRolesWithEmail(userEmail).subscribe(result => {
        if (AppConstants.isNotNullCondition(result) && result.length > 0) {
          let value = '';
          result.forEach(x => {
            if (x.roleName === carrier_user || x.roleName === carrier_user_admin || x.roleName === carrier_user_RF || x.roleName === carrier_user_paygov) {
              value += '<div>' + x.scacName + ' : ' + x.roleName + ' : ' + '(' + x.permission + ')' + '<div>';
            } else {
              value += '<div>' + x.agencyBureauName + ' : ' + x.roleName + ' : ' + '(' + x.permission + ')'  +'<div>';
            }
          });
          this.modalRef = this.modalService.show(ConfirmationModalComponent);
          this.modalRef.content.body = value;
          this.modalRef.content.title = 'User already exists! Are you sure, you want to create?';
          this.modalRef.content.confirmText = 'Yes';
          this.modalRef.content.cancelText = 'No';
          this.modalRef.content.emitData.subscribe(res => {
            if (res.obj === true) {
              this.callCreate(creatModal);
            }
            return;
          });
        } else {
          this.callCreate(creatModal);
        }
      });
    }
  }

  callCreate(creatModal) {
    this.tmssloader.show();
    this.organizationId = this.routeParamOrganizationId;
    this.roles = [];
    if (true === this.isAgencyUser) {
      for (const role of this.agencyUserRoles) {
        if (role.name === this.agencyUserForm.get('agencyUserRole').value) {
          this.roles.push(role);
        }
      }
    } else {
      for (const role of this.carrierUserRoles) {
        if (role.name === this.agencyUserForm.get('agencyUserRole').value) {
          this.roles.push(role);
        }
      }
    }
    this.agencyUserForm.controls['roles'].setValue(this.roles);
    const payload = this.agencyUserForm.value;
    payload.email = this.agencyUserForm.controls['email'].getRawValue().trim();
    this.agencyUserService.createUser(payload, this.organizationId)
      .subscribe(response => {
          this.tmssloader.hide();
        },
        (err: HttpErrorResponse) => {
          if (200 === err.status) {
            this.getAgencyUsersList(this.organizationId);
            this.message = 'The User has been successfully added and an email notification with log in instructions has been sent to the User.';
            creatModal.hide();
            this.alertService.success(this.message);
          } else if (404 === err.status) {
            this.message = 'Could not connect to server, please try again later. Please report the issue to administrator if the problem persists.';
          } else {
            this.message = err.error;
          }
          this.tmssloader.hide();
        });
  }

  // Function to update the existing user by user details and organizationId
  updateUser(creatModal?) {
    this.tmssloader.show();
    this.organizationId = this.routeParamOrganizationId;
    this.roles = [];
    if (true === this.isAgencyUser) {
      for (const role of this.agencyUserRoles) {
        if (role.name === this.agencyUserForm.get('agencyUserRole').value) {
          this.roles.push(role);
        }
      }
    } else {
      for (const role of this.carrierUserRoles) {
        if (role.name === this.agencyUserForm.get('agencyUserRole').value) {
          this.roles.push(role);
        }
      }
    }
    this.agencyUserForm.controls['roles'].setValue(this.roles);
    const payload = this.agencyUserForm.value;
    payload.email = this.agencyUserForm.controls['email'].getRawValue().trim();
    this.agencyUserService.updateUser(payload, this.organizationId)
      .subscribe(response => {
          this.tmssloader.hide();
        },
        (err: HttpErrorResponse) => {
          if (200 === err.status) {
            this.getAgencyUsersList(this.organizationId);
            this.message = 'User details have been updated successfully.';
            creatModal.hide();
            this.alertService.success(this.message);
          } else if (404 === err.status) {
            this.message = 'Could not connect to server, please try again later. Please report the issue to administrator if the problem persists.';
          } else {
            this.message = err.error;
          }
          this.tmssloader.hide();
        });

  }

  // Function allows the existing user agency/Carrier user to reset password at OKTA
  resetPassword(creatModal?) {
    this.tmssloader.hide();

    this.organizationId = this.routeParamOrganizationId;

    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    if (true === this.reactivateUser) {
      this.modalRef.content.question = 'Are you sure, you want to reactivate this User?';
      this.modalRef.content.title = 'Reactivate User';
    } else {
      this.modalRef.content.question = 'Are you sure, you want to reset the password for this User?';
      this.modalRef.content.title = 'Reset Password';
    }

    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.userEmail = this.agencyUserForm.get('email').value;
        this.agencyUserForm.controls['roles'].setValue(this.roles);
        this.tmssloader.show();
        this.agencyUserService.resetPassword(this.agencyUserForm.value, this.organizationId)
          .subscribe(response => {
              this.getAgencyUsersList(this.organizationId);
              this.message = 'Temporary password has been sent in email to the user.';
              this.tmssloader.hide();
            },
            (err: HttpErrorResponse) => {
              if (200 === err.status) {
                this.getAgencyUsersList(this.organizationId);
                this.message = 'Temporary password has been sent in email to the user.';
                // this.message = 'Temporary password has been sent in email to the user.'; //this message to be shown at main page
                creatModal.hide();
                this.alertService.success(this.message);
              } else if (404 === err.status || 400 === err.status) {
                this.message = 'Could not connect to server, please try again later. Please report the issue to administrator if the problem persists.';
              } else {
                this.message = err['text'];
              }
              this.tmssloader.hide();
            });
      }

    });

  }

  // function to soft delete the existing user by just updating the user_status to 'Deleted'
  deleteUser(creatModal?) {
    this.tmssloader.hide();
    this.organizationId = this.routeParamOrganizationId;
    if (null !== this.organizationId && null !== this.agencyUserForm.get('id').value) {
      // User clicked Delete button on the pop up
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to delete this User?';
      this.modalRef.content.title = 'USER DELETE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          if (true === this.isAgencyUser) {
            for (const role of this.agencyUserRoles) {
              if (role.name === this.agencyUserForm.get('agencyUserRole').value) {
                this.roles.push(role);
              }
            }
          } else {
            for (const role of this.carrierUserRoles) {
              if (role.name === this.agencyUserForm.get('agencyUserRole').value) {
                this.roles.push(role);
              }
            }
          }
          this.agencyUserForm.controls['roles'].setValue(this.roles);
          this.idOfSelectedUser = this.agencyUserForm.get('id').value;
          this.tmssloader.show();
          this.agencyUserService.deleteUser(this.agencyUserForm.value, this.organizationId)
            .subscribe(response => {
                this.tmssloader.hide();
              },
              (err: HttpErrorResponse) => {
                if (200 === err.status) {
                  for (const agencyUser of this.agencyUserList) {
                    if (agencyUser.id === this.idOfSelectedUser) {
                      const indexForUserDelete = this.agencyUserList.indexOf(agencyUser);
                      this.agencyUserList.splice(indexForUserDelete, 1);
                      this.gridApi.setRowData(this.agencyUserList);
                      break;
                    }
                  }
                  // this.setupPagination();
                  this.tmssloader.hide();
                  this.message = 'User has been deleted successfully.';
                  // this.message = 'User has been deleted successfully.'; //this message to be shown at main page
                  creatModal.hide();
                  this.alertService.success(this.message);

                } else if (404 === err.status) {
                  this.message = 'Could not connect to server, please try again later. Please report the issue to administrator if the problem persists.';
                } else {
                  this.message = err.error;
                }
                this.tmssloader.hide();
              });
        }
      });
    }
  }
  /**
   * @description goes to AgencyProfile with appropriate queryParams when user clicks on agencyprofile
   */
  goToAgencyProfile() {
    if (AppConstants.isNotNullCondition(this.routeParamOrganizationId)) {
      this.router.navigate(['/agencyprofile'], {
        queryParams: {
          orgId: this.routeParamOrganizationId,
          isAgencyUser: this.isAgencyUser,
          isFromUserProfile: !this.isFromUserProfile
        }
      });
    } else {
      this.alertService.info('There is no organization ID provided, Please contact system administrator.');
    }
  }

  /**
   * @description goes to CarrierProfile with appropriate queryParams when user clicks on CarrierProfile
   */
  goToCarrierProfile() {
    if (AppConstants.isNotNullCondition(this.routeParamOrganizationId) ||
      AppConstants.isNotNullCondition(this.isAgencyUser) || AppConstants.isNotNullCondition(this.isFromUserProfile)) {
      this.router.navigate(['/carrierprofile'], {
        queryParams: {
          orgId: [this.routeParamOrganizationId],
          isAgencyUser: [!this.isAgencyUser],
          isFromUserProfile: [!this.isFromUserProfile]
        }
      });
    } else {
      this.alertService.info('There is no organization ID provided, Please contact system administrator.');
    }
  }

  /**
   * @description goes to UserProfile with appropriate queryParams when user clicks UserProfile
   */
  goToUserProfile() {
    if (AppConstants.isNotNullCondition(this.routeParamUserIdFromUserProfile)) {
      this.router.navigate(['/userprofile'], {
        queryParams: {userId: [this.routeParamUserIdFromUserProfile]}
      });
    } else {
      this.alertService.info('There is no User ID provided, Please contact system administrator.');
    }
  }

  /**
   * @description goes to AgencyTspSearch when user clicks on Search
   */
  goToAgencyTspSearch() {
    this.router.navigate(['/agencytspsearch'], {});
  }

  /**
   * @description unsibscribes to all the subscriptions if there are any.
   */
  ngOnDestroy() {
  }
}
